













































































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../shared/services/mixin";
import {Component, Watch} from "vue-property-decorator";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {ComplaintStatus} from "@/enums/status";
import {debounce} from "lodash";
import {ComplaintCustomerStore} from "@/modules/complaintcustomer/store";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import {ComplaintCustomerParams} from "@/modules/complaintcustomer/params";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";
import ComplaintCustomerDetail from "@/modules/complaintcustomer/Detail/index.vue";

const columns = [
    {
        title: "STT",
        dataIndex: "stt",
        key: "stt",
        width: 60,
        ellipsis: true
    },
    {
        title: "Thao tác",
        dataIndex: "id",
        key: "id",
        width: 80,
        ellipsis: true,
        scopedSlots: { customRender: 'action' },
        align: 'center'
    },
    {
        title: "Mã đơn hàng",
        dataIndex: "billLading.ladingCode",
        key: "ladingCode",
        width: 150,
        ellipsis: true,
        scopedSlots: { customRender: 'ladingCode' }
    },
    {
        title: "Nội dung khiếu nại",
        dataIndex: "content",
        key: "content",
        width: 200,
        ellipsis: true,
        scopedSlots: { customRender: 'content' }
    },
    {
        title: "Trả lời",
        dataIndex: "answer",
        key: "answer",
        width: 200,
        ellipsis: true,
        scopedSlots: { customRender: 'answer' }
    },
    {
        title: "Người nhận",
        dataIndex: "billLading.locationTo",
        key: "locationToName",
        width: 150,
        ellipsis: true,
        scopedSlots: { customRender: 'locationToName' }
    },
    {
        title: "SDT Người nhận",
        dataIndex: "billLading.locationTo",
        key: "locationToPhoneNumber",
        width: 150,
        ellipsis: true,
        scopedSlots: { customRender: 'locationToPhoneNumber' }
    },
    {
        title: "Địa chỉ",
        dataIndex: "billLading.locationTo",
        key: "locationToAddress",
        width: 500,
        ellipsis: true,
        scopedSlots: { customRender: 'locationToAddress' }
    },
    {
        title: "Hàng hóa",
        dataIndex: "billLading.boxContent",
        key: "boxContent",
        width: 150,
        ellipsis: true,
        scopedSlots: { customRender: 'boxContent' }
    },
    {
        title: "Trạng thái",
        dataIndex: "status",
        key: "status",
        width: 120,
        ellipsis: true,
        scopedSlots: { customRender: 'status' }
    }
];
@Component({
    name: "ListComplaintCustomer",
    components: {ComplaintCustomerDetail, TooltipLabel, EnumSelector}
})
export default class extends mixins(CommonMixin){
    ComplaintStatus = ComplaintStatus;
    columns = [...columns];
    params = new ComplaintCustomerParams();
    visibleDetail = false;
    selectedId: number = null as any;

    get complaintCustomers() {
        return ComplaintCustomerStore.ids.map((id: number) => ComplaintCustomerStore.data[id]);
    }

    created() {
        ComplaintCustomerStore.updateComplaintCustomerParams(new ComplaintCustomerParams());
        this.listComplaintCustomer(ComplaintCustomerStore.params);
    }

    async listComplaintCustomer(params: any) {
        try {
            await ComplaintCustomerStore.listComplaintCustomer(params);
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Đã xảy ra lỗi");
        }
    }

    get pagination() {
        return {
            current: ComplaintCustomerStore.meta.page,
            pageSize: ComplaintCustomerStore.meta.limit,
            total: ComplaintCustomerStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} khiếu nại`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        ComplaintCustomerStore.updateComplaintCustomerParams({...ComplaintCustomerStore.params, page: pagination.current, limit: pagination.pageSize});
        this.listComplaintCustomer(ComplaintCustomerStore.params);
    }

    @Watch("params", { deep: true })
    onChangeParams(val: any) {
        this.handleChangeParams(val, this);
    }

    handleChangeParams = debounce((val: any, vm) => {
        ComplaintCustomerStore.updateComplaintCustomerParams({...val, page: 1});
        vm.listComplaintCustomer(ComplaintCustomerStore.params);
    }, 500)
}
